//imports
import React, { useEffect, useState } from "react";
import {
  Box,
  AppBar,
  Grid,
  Stack,
  Autocomplete,
  TextField,
  CircularProgress,
  Breadcrumbs,
  Link,
  Button,
  Chip,
} from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { externalgetApi } from "../../services/external/externalApis";
import { ORDER_API_03 } from "../../api/ApiModel";
import {
  CON_STATUS_ACTIVE,
  CON_STATUS_DELETED,
  CON_STATUS_PENDING,
  CON_STATUS_RETURN,
} from "../../utils/sys/Constants";
import { useSelector } from "react-redux";
import Navbar from "../../components/common/Navbar";
import ViewData from "../../components/grids/ViewDatagrid";
import VisibilityIcon from "@mui/icons-material/Visibility";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import { Orderlistdata } from "../../assets/Griddata";
import { useStyles } from "../../assets/styles/Theme";
import { currencyFormatLKR } from "../../utils/common/CurrencyFormat";
import PhonelinkEraseIcon from "@mui/icons-material/PhonelinkErase";
import CurrencyExchangeRoundedIcon from "@mui/icons-material/CurrencyExchangeRounded";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

//hooks
const currentDate = new Date();
const currentYear = currentDate.getFullYear();
const currentMonth = String(currentDate.getMonth() + 1).padStart(2, "0");

const startOfMonth = dayjs().startOf("month");

const endOfMonthDate = dayjs().endOf("month");
function OrderList() {
  //hooks
  const [orderData, setOrderData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [selectedStatus, setSelectedStatus] = useState({
    ORDERSTATUSCODE: CON_STATUS_ACTIVE,
    ORDERSTATUSNAME: "Active",
  });
  const [fromDate, setFromDate] = useState(startOfMonth);
  const [toDate, setToDate] = useState(endOfMonthDate);
  const navigate = useNavigate();
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, RESTCODE } = SYS_USER.USER_PARAM || {};

  const orderStatuses = [
    { ORDERSTATUSCODE: CON_STATUS_ACTIVE, ORDERSTATUSNAME: "Active" },
    { ORDERSTATUSCODE: CON_STATUS_PENDING, ORDERSTATUSNAME: "Pending" },
    { ORDERSTATUSCODE: CON_STATUS_RETURN, ORDERSTATUSNAME: "Return" },
  ];

  const theme = useTheme();
  const styles = useStyles(theme);

  useEffect(() => {
    if (selectedStatus.ORDERSTATUSCODE) {
      fetchOrderData(selectedStatus.ORDERSTATUSCODE);
    }
  }, [selectedStatus, fromDate, toDate]);
  const handleDateChange = (newValue) => {
    if (newValue) {
      // Format the date to YYYY-MM-DD before sending to API
      const formattedDate = newValue.format("MM/DD/YYYY");
      setFromDate(dayjs(formattedDate));
    } else {
      setFromDate(""); // Handle null case
    }
  };

  const handleToDateChange = (newValue) => {
    if (newValue) {
      // Format the date to YYYY-MM-DD before sending to API
      const formattedDate = newValue.format("MM/DD/YYYY");
      setToDate(dayjs(formattedDate));
    } else {
      setToDate(""); // Handle null case
    }
  };
  const fetchOrderData = async (statusCode) => {
    setLoading(true);
    const params = {
      COMPCODE,
      LOCCODE,
      RESTCODE,
      FROMDATE: dayjs(fromDate).format("MM-DD-YYYY"),
      TODATE: dayjs(toDate).format("MM-DD-YYYY"),
      STS:
        statusCode === CON_STATUS_ACTIVE
          ? CON_STATUS_ACTIVE
          : statusCode === CON_STATUS_PENDING
          ? CON_STATUS_PENDING
          : statusCode === CON_STATUS_DELETED
          ? CON_STATUS_DELETED
          : CON_STATUS_RETURN,
    };
    try {
      const response = await externalgetApi(ORDER_API_03, "GET", params);
      setOrderData(response || []);
    } catch (err) {
      console.error("Failed to fetch order data:", err);
    } finally {
      setLoading(false);
    }
  };

  const mapResultToRows = (result) => {
    return result.map((item, index) => ({
      id: index + 1,
      INVNO: item.INVNO,
      ORDERCODE: item.ORDERCODE,
      ORDERENDATE: item.ORDERENDATE,
      STS:
        item.STS === CON_STATUS_ACTIVE ? (
          <Chip
            label="Order Placed"
            variant="filled"
            sx={{
              boxShadow: 2,
            }}
            color="success"
          />
        ) : item.STS === CON_STATUS_PENDING ? (
          <Chip label="Pending" variant="filled" color="error" />
        ) : item.STS === CON_STATUS_DELETED ? (
          <Chip label="Cancelled" variant="filled" color="warning" />
        ) : item.STS === CON_STATUS_RETURN ? (
          <Chip label="Returned" variant="filled" color="primary" />
        ) : null,

      AMOUNT: currencyFormatLKR(item.AMOUNT, "LKR", false),
    }));
  };
  //handlers
  const handleStatusChange = (status) => {
    setSelectedStatus(status);
  };

  const handleItemClick = (ORDERCODE, actionText) => {
    const selectedItem = orderData.find((item) => item.ORDERCODE === ORDERCODE);
    if (selectedItem) {
      navigate(`/ordercancel`, {
        state: { selectedItem, actionText, ORDERCODE },
      });
    }
  };

  const handleItemClick1 = (ORDERCODE, actionText) => {
    const selectedItem = orderData.find((item) => item.ORDERCODE === ORDERCODE);
    if (selectedItem) {
      navigate(`/orderreturn`, {
        state: { selectedItem, actionText, ORDERCODE },
      });
    }
  };

  const menuItems = [
    {
      text: "Cancel",
      icon: <PhonelinkEraseIcon />,
      onClick: (ORDERCODE) => handleItemClick(ORDERCODE, "Cancel"),
    },
    {
      text: "Return/Refund",
      icon: <CurrencyExchangeRoundedIcon />,
      onClick: (ORDERCODE) => handleItemClick1(ORDERCODE, "Return"),
    },
  ];

  return (
    <>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer1}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                separator={<NavigateNextIcon fontSize="small" />}
                sx={styles.AI_breadcrumbs2}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Returns</Link>
                <Link underline="none">Order List</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item p={2}>
              <Stack
                direction="row"
                justifyContent="flex-end"
                spacing={2}
                padding={1}
                ml={1}
                sx={styles.AI_fixedStack1}
              ></Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>
      <Box sx={styles.OL_AddStyledBox}>
        {/* <Grid container spacing={1}> */}
        {/* First Row: Back Button */}

        {/* Second Row: Select Location, From Date, To Date, Report Button */}
        <Grid
          container
          spacing={2}
          mr={15}
          sx={styles.OL_AddStyledBox_container}
        >
          <Grid item xs={12} md={2}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="From Date"
                value={fromDate}
                onChange={handleDateChange}
                inputFormat="MM/DD/YYYY"
                slotProps={{
                  textField: {
                    sx: {
                      width: "100%",
                      "& .MuiInputBase-root": {
                        height: "40px",
                      },
                      "& .MuiInputAdornment-root .MuiIconButton-root": {
                        color: theme.palette.primary.main, // Change icon color here
                      },
                    },
                  },
                  popper: {
                    sx: {
                      "& .MuiPaper-root": {
                        backgroundColor: theme.palette.background.paper, // Background color of the popper
                        boxShadow: "none", // Remove box shadow if needed
                      },
                    },
                  },
                }}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} md={2}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="To Date"
                value={toDate}
                onChange={handleToDateChange}
                inputFormat="MM/DD/YYYY"
                slotProps={{
                  textField: {
                    sx: {
                      width: "100%",
                      "& .MuiInputBase-root": {
                        height: "40px",
                      },
                      "& .MuiInputAdornment-root .MuiIconButton-root": {
                        color: theme.palette.primary.main, // Change icon color here
                      },
                    },
                  },
                  popper: {
                    sx: {
                      "& .MuiPaper-root": {
                        backgroundColor: theme.palette.background.paper, // Background color of the popper
                        boxShadow: "none", // Remove box shadow if needed
                      },
                    },
                  },
                }}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={0} md={4}></Grid>
          <Grid item xs={12} md={4}>
            <Autocomplete
              value={selectedStatus}
              onChange={(event, newValue) => handleStatusChange(newValue)}
              options={orderStatuses}
              getOptionLabel={(option) => option.ORDERSTATUSNAME || ""}
              isOptionEqualToValue={(option, value) =>
                option.ORDERSTATUSCODE === value?.ORDERSTATUSCODE
              }
              disableClearable
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Order Status"
                  variant="outlined"
                  size="small"
                  sx={{
                    "& .MuiInputBase-root": {
                      minWidth: "200px",
                      // height: "43px",
                      // width: "300px",
                    },
                  }}
                />
              )}
              ListboxProps={{
                style: {
                  maxHeight: 180,
                  backgroundColor: theme.palette.background.paper,
                },
              }}
            />
          </Grid>
        </Grid>
        {/* </Grid> */}
      </Box>
      <Box sx={styles.OL_vdg}>
        {loading ? (
          <CircularProgress />
        ) : (
          <ViewData
            columns={Orderlistdata.columns}
            rows={mapResultToRows(orderData)}
            menuItems={menuItems}
            tabletitle={Orderlistdata.name}
            gridid="ORDERCODE"
          />
        )}
      </Box>
    </>
  );
}

export default OrderList;
